import React from 'react'
import UseLang from '../../../../hooks/UseLang'

function DescargarArchivo() {
    return (
        <div className='DownloadFile'> 
            <UseLang es>
                <a className="buttons button_blue" href="/reportes/ciberseguridad/investigacion-sobre-ataques-ddos-es.pdf" target="_blank">Descargar PDF</a>
            </UseLang>
            <UseLang en>
                <a className="buttons button_blue" href="/reportes/ciberseguridad/investigacion-sobre-ataques-ddos-en.pdf" target="_blank">Download PDF</a>
            </UseLang>
            <UseLang pt>
                <a className="buttons button_blue" href="/reportes/ciberseguridad/investigacion-sobre-ataques-ddos-pt.pdf" target="_blank">Baixar PDF</a>
            </UseLang>
        </div>
    )
}

export default DescargarArchivo
